import { MediaSet } from 'ca-api-client';

export default class MoveToSet {
    config() {
        return {
            title: 'Move to collection',
            description:
                'Choose an existing collection to move the selected items to.',
            mode: 'single',
            sets: true,
            media: false,
            tree: true,
            upload: {
                allow: false,
            },
            defaultFilters: [],
            filterOptions: [],
        };
    }
    async doAction() {
        console.log('MoveToSet::doAction()');

        const options = App.$store.getters.getMediaSelectOptions;
        const itemTypes = App.$store.getters.getMediaSetSelectedByType;
        const selected = App.$store.getters.getMediaSelectSelected.pop();

        return new Promise(async resolve => {
            const promises = [];

            if (selected) {
                const set = await MediaSet.params({
                    include: 'children',
                }).$find(options.itemId);
                const media = set.mediaIds.filter(
                    i => !itemTypes.media.includes(i)
                );
                const children = set.childIds.filter(
                    i => !itemTypes.sets.includes(i)
                );

                // remove media/children from current set
                promises.push(
                    set.patch({
                        media,
                        children,
                    })
                );

                // update target sets media/children
                promises.push(
                    App.$store.dispatch('updateSet', {
                        id: selected.id,
                        data: {
                            media: itemTypes.media,
                            children: itemTypes.sets,
                        },
                    })
                );
            } else {
                // has no set is root gallery
                itemTypes.sets.forEach(async setId => {
                    promises.push(
                        App.$store.dispatch('removeSetParent', setId)
                    );
                });

                // remove media from set
                itemTypes.media.forEach(async mediaId => {
                    promises.push(
                        App.$store.dispatch('removeItemFromSet', mediaId)
                    );
                });
            }

            Promise.all(promises).then(response => {
                resolve({ id: selected.id, response });
            });
        });
    }
}
